import {
    DocumentData,
    DocumentReference,
    DocumentSnapshot,
    Firestore,
    QueryDocumentSnapshot,
    collection,
    doc,
    getDoc,
    getDocs,
    limit,
    query,
    where
} from 'firebase/firestore'

import { getApp } from 'firebase/app'

import { initializeFirestore } from 'firebase/firestore'

export enum IEventName {
    SETUP_WHITELABEL_LOGO = 'SETUP_WHITELABEL_LOGO',
    SETUP_WHITELABEL_API_DOMAIN = 'SETUP_WHITELABEL_API_DOMAIN',
    SETUP_WHITELABEL_DOMAIN = 'SETUP_WHITELABEL_DOMAIN',
    SETUP_EMAIL_SERVICES = 'SETUP_EMAIL_SERVICES',
    SETUP_PHONE_SERVICES = 'SETUP_PHONE_SERVICES',
    CREATE_SNAPSHOT = 'CREATE_SNAPSHOT',
    IMPORT_SNAPSHOT = 'IMPORT_SNAPSHOT',
    LOAD_SNAPSHOT = 'LOAD_SNAPSHOT',
    SETUP_SUBACCOUNT = 'SETUP_SUBACCOUNT',
    GENERATE_PROSPECT = 'GENERATE_PROSPECT',
    GENERATE_MARKETING_REPORT = 'GENERATE_MARKETING_REPORT',
    SETUP_NEW_SAAS_PLAN = 'SETUP_NEW_SAAS_PLAN',
    SETUP_SAAS_SNAPSHOT = 'SETUP_SAAS_SNAPSHOT',
    SETUP_SAAS_ADDONS = 'SETUP_SAAS_ADDONS',
    CONNECT_STRIPE = 'CONNECT_STRIPE',
    CREATE_FUNNEL = 'CREATE_FUNNEL',
    CREATE_FUNNEL_STEP = 'CREATE_FUNNEL_STEP',
    PUBLISH_FUNNEL = 'PUBLISH_FUNNEL' 
}

export enum LaunchpadAgencySegmentStatus {
    PENDING = 'pending',
    COMPLETED = 'completed'
}

export enum SegmentTypesEnum {
    AGENCY = 'agency',
    LOCATION = 'location'
}

export interface IStepInfo {
    id: string
    eventName: IEventName
    status: LaunchpadAgencySegmentStatus
    notified: boolean
    checkStatus: boolean
    productId: string
}

export interface ILaunchpadAgencyProgress {
    stepInfo: IStepInfo[]
    refId: string
    type: SegmentTypesEnum
}

let launchpadFirestore: Firestore
const getLaunchpadFirestore = () => {
    if (launchpadFirestore) {
        return launchpadFirestore
    }
    const database = (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'beta') 
        ? 'leadgen-onboarding-production' 
        : 'leadgen-onboarding-staging'
    
    launchpadFirestore = initializeFirestore(getApp(), {}, database)
    console.log('launchpadFirestore:', launchpadFirestore)

    return launchpadFirestore
}

export default class AgencyLaunchpadProgress {
    public static collectionRef() {
        return collection(getLaunchpadFirestore(), 'agency_launchpad_progress')
    }

    private _data: DocumentData
    private _id: string
    private _ref: DocumentReference
    private _snapshot: DocumentSnapshot

    constructor(
        snapshot?: DocumentSnapshot | QueryDocumentSnapshot | { [key: string]: any }
    ) {
        if (
            snapshot instanceof DocumentSnapshot ||
            snapshot instanceof QueryDocumentSnapshot
        ) {
            this._id = snapshot.id
            this._data = snapshot.data() || {}
            this._ref = snapshot.ref
            this._snapshot = snapshot
        } else if (snapshot) {
            this._id = snapshot.id
            this._data = snapshot
            this._ref = doc(AgencyLaunchpadProgress.collectionRef(), snapshot.id)
        } else {
            this._ref = doc(AgencyLaunchpadProgress.collectionRef())
            this._id = this._ref.id
            this._data = {}
        }
    }

    public static getById(id): Promise<AgencyLaunchpadProgress> {
        return new Promise(async(resolve, reject) => {
            const docRef = doc(getLaunchpadFirestore(), 'agency_launchpad_progress', id)
            const snapshot = await getDoc(docRef)

            if (snapshot.exists()) {
                resolve(new AgencyLaunchpadProgress(snapshot))
            } else {
                reject(new Error(`Document with ID ${id} does not exist`))
            }
        })
    }

    public static getByRefId(refId: string): Promise<AgencyLaunchpadProgress> {
        return new Promise(async (resolve, reject) => {
            try {
                const colRef = AgencyLaunchpadProgress.collectionRef()
                const q = query(colRef, 
                    where('refId', '==', refId),
                    where('deleted', '==', false)
                )
                
                const snapshot = await getDocs(q)
                
                if (!snapshot.empty) {
                    resolve(
                        new AgencyLaunchpadProgress(
                            snapshot.docs[0] as QueryDocumentSnapshot<DocumentData>
                        )
                    )
                } else {
                    reject(new Error(`No document found with refId: ${refId}`))
                }
            } catch(err) {
                reject(err)
            }
        })
    }

    public static fetchByRefId(refId: string) {
        const colRef = AgencyLaunchpadProgress.collectionRef()
        return query(colRef, 
            where('refId', '==', refId),
            where('deleted', '==', false),
            limit(1)
        )
    }

    get ref(): DocumentReference {
        return this._ref
    }

    get snapshot() {
        return this._snapshot
    }

    get data(): DocumentData {
        return this._data
    }

    get stepInfo(): IStepInfo[] {
        return this._data.stepInfo
    }

    set stepInfo(stepInfo: IStepInfo[]) {
        this._data.stepInfo = stepInfo
    }

    get refId(): string {
        return this._data.refId
    }

    set refId(refId: string) {
        this._data.refId = refId
    }

    get type(): SegmentTypesEnum {
        return this._data.type
    }

    set type(type: SegmentTypesEnum) {
        this._data.type = type
    }
}
  